import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: {},
  errors: {},
  requesting: null,
  submitting: null,
  isSaved: false,
};

const Slice = createSlice({
  name: '@admin/Inventory|Types|Form',
  initialState,
  reducers: {
    
    /**
     * RESET
     */
    initialState: (state) => {
      state.requesting = null;
      state.submitting = null;
      state.errors = {};
      state.type = {};
      state.isSaved = false;
    },

    /**
     * GET TYPE
     */
    getType: (state) => {
      state.requesting = true;
      state.type = {};
    },
    getTypeSuccess: (state, action) => {
      const { payload } = action;
      state.type = payload;
      state.requesting = false;
    },
    getTypeFailed: (state, action) => {
      state.errors = action.payload;
      state.requesting = false;
    },

    /**
     * SAVE FORM
     */
    saveForm: (state) => {
      state.submitting = true;
      state.isSaved = false;
      state.errors = {};
    },
    saveFormSuccess: (state, action) => {
      const { payload } = action;
      state.type = payload;
      state.submitting = false;
      state.isSaved = true;
    },
    saveFormFailed: (state, action) => {
      state.errors = action.payload;
      state.submitting = false;
      state.isSaved = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminInventoryTypesFormReducers: Slice.reducer,
}
export default Reducers;
